import * as React from 'react';

import iconUrl from './Builder.svg';

type IBuilderProps = React.ImgHTMLAttributes<HTMLImageElement>;

export function Builder(props: IBuilderProps) {
  return <img {...props} width="14" height="18" src={iconUrl} alt="" />;
}
